import { readAuthToken, clearAuthToken, authContextKey } from '../lib/authSession'
export class ApiHttpError extends Error {
  status: number;
  code?: string;
  details?: any;

  constructor(message: string, status: number, code?: string, details?: any) {
    super(message);
    this.name = 'ApiHttpError';
    this.status = status;
    this.code = code;
    this.details = details;
  }
}

export async function apiFetch(
  url: string,
  options: RequestInit = {}
) {
  const API_URL = import.meta.env.VITE_API_URL ?? '';
  const token = readAuthToken();
  const context = authContextKey();

  try {
    const response = await fetch(`${API_URL}${url}`, {
      method: options.method || 'GET',
      cache: 'no-store',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        ...(options.headers || {}),
      },
    });

    if (context !== authContextKey() || (response.status === 401 && token !== readAuthToken())) throw new DOMException('Session changed', 'AbortError');
    if (!response.ok) {
      let errorData;
      const contentType = response.headers.get('content-type');

      if (contentType && contentType.includes('application/json')) {
        try {
          errorData = await response.json();
        } catch (parseError) {
          const textResponse = await response.text();
          errorData = { message: textResponse || `Erreur API: ${response.statusText}` };
        }
      } else {
        const textResponse = await response.text();
        errorData = { message: textResponse || `Erreur API: ${response.statusText}` };
      }

      if (response.status === 401) {
        clearAuthToken();
        throw new Error('Token expiré ou non valide. Veuillez vous reconnecter.');
      }

      throw new ApiHttpError(
        errorData.message || `Erreur API: ${response.status} ${response.statusText}`,
        response.status,
        errorData.code,
        errorData
      );
    }

    return response;
  } catch (error: any) {
    console.error("Erreur lors de l'appel API:", error);
    if (error instanceof ApiHttpError) {
      throw error;
    }
    throw new Error(error.message || "Une erreur réseau est survenue.");
  }
}
